module.exports = __webpack_public_path__ + "img/c-en-08.8383c185.png";